// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getAuth} from 'firebase/auth'

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDRrZdga0CE0RXMlUP73q_o_djb9CPC5v0",
  authDomain: "amit-sir-project.firebaseapp.com",
  projectId: "amit-sir-project",
  storageBucket: "amit-sir-project.appspot.com",
  messagingSenderId: "840554206665",
  appId: "1:840554206665:web:44b5944811670013938418",
  measurementId: "G-PWMQSFPQSX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export  const auth = getAuth(app)
